/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Agent_Abilities_Chip2_LabelInputs */



/**
* | output |
* | --- |
* | "Will it act without asking?" |
*
* @param {Uno_Edu_Agent_Abilities_Chip2_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_agent_abilities_chip2_label = /** @type {((inputs?: Uno_Edu_Agent_Abilities_Chip2_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Agent_Abilities_Chip2_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Handelt er, ohne zu fragen?")
	return /** @type {LocalizedString} */ ("Will it act without asking?")
});